import {
  SearchApiModel,
  useAxios,
  useDeleteNulls,
  useHandleApiError,
} from '@sttedra_ui/framework';

import ProtectedAreaApiResponseModel from './protected-area.api-response-model.js';

// #region Globals
const {base} = useAxios();
const CONTEXT_BASE_PATH = 'espaciosprotegidos';
const DEFAULT_TIMEOUT = 5000;
const {handleApiError} = useHandleApiError();
// #endregion

// #region Public functions

async function searchProtectedArea(searchParams = {}, throwError = true) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = '/' + CONTEXT_BASE_PATH;

    const {data: response} = await base.post(url, searchModel, {
      timeout: DEFAULT_TIMEOUT,
    });

    const {data: originalData, pageSize, pageIndex, totalResults} = response;

    const data = originalData.map((u) => new ProtectedAreaApiResponseModel(u));

    return {data, pageSize, pageIndex, totalResults};
  } catch (err) {
    if (!throwError) {
      return handleApiError(err);
    }
    throw err;
  }
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  searchProtectedArea,
};
